export default __webpack_public_path__ + "content/media/17.3843dad0.jpg";